var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit" },
    [
      _vm.managerAffiliateModalOpen ? _c("manager-affiliate-modal") : _vm._e(),
      _c("Grid", {
        attrs: {
          id: "managerAffiliate",
          data: _vm.affiliateManagers,
          columns: _vm.columnOptions,
          onRequest: _vm.fetchAffiliateManagers,
          loading: _vm.affiliateManagersLoading,
          selected: _vm.selectedAffiliateManagers,
          selectable:
            _vm.affiliateManagers && _vm.affiliateManagers.length === 1
              ? "none"
              : "multiple",
          onSelect: _vm.updateSelectedAffiliateManagers,
          hideSelectAll: true,
          "hide-count": ""
        },
        scopedSlots: _vm._u([
          {
            key: "header-left",
            fn: function(props) {
              return [
                _c(
                  "q-btn",
                  {
                    attrs: {
                      color: "primary",
                      outline: "",
                      icon: "fa fa-user-plus"
                    },
                    on: {
                      click: function($event) {
                        _vm.openManagerAffiliateModal()
                      }
                    }
                  },
                  [_vm._v(" Add Manager")]
                ),
                _vm._v(" \n      "),
                _vm.selectedAffiliateManagers.length > 0
                  ? _c(
                      "q-btn",
                      {
                        attrs: { color: "red" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.onRemoveManager($event)
                          }
                        }
                      },
                      [_vm._v("Remove")]
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "col-item-active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value === 1,
                      red: props.value === 0
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-date_created",
            fn: function(props) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.moment(props.value).format("MMMM Do, YYYY h:mm A")
                    ) +
                    "\n    "
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }